(() => {
  if (window.lpLimitedProductInitialized) return;
  window.lpLimitedProductInitialized = true;
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.disabled || !input.checked) return;
    const scope = input.closest('[data-lp-limited-product]');
    if (!scope || !input.matches('variant-picker input[type="radio"]')) return;
    const form = scope.querySelector('product-form-component form');
    const data = form?.querySelector('[data-lp-checkout-variants]');
    const variants = data ? JSON.parse(data.textContent) : [];
    const variant = variants.find(item => String(item.id) === input.dataset.variantId);
    const price = scope.querySelector('[data-lp-edition-price-display]');
    if (price && variant) price.textContent = variant.priceText;
  });
  document.addEventListener('variant:selected', event => {
    const scope = event.target instanceof Element ? event.target.closest('[data-lp-limited-product]') : null;
    if (!scope) return;
    scope.querySelector('[ref="addToCartButton"]')?.setAttribute('disabled', '');
    scope.querySelector('[ref="acceleratedCheckoutButtonContainer"]')?.setAttribute('hidden', '');
  });
})();
